import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core'
import { CpmService } from 'app/service/cpm.service'
import { FormBuilder, FormGroup, FormControl, FormArray } from '@angular/forms'
@Component({
  selector: 'app-trading-compare-to-peer-popup',
  templateUrl: './trading-compare-to-peer-popup.component.html',
  styleUrls: ['./trading-compare-to-peer-popup.component.scss']
})
export class TradingCompareToPeerPopupComponent implements OnInit {
  @Output() closeModal = new EventEmitter()
  symbol
  radio
  period
  securityIdPsims

  @Input('dataTrading') dataTrading: any
  headerTradingComparePopu
  tradingForm: FormGroup

  searchInput
  searchResults
  securityList
  informationFromSecurityTrading
  selectData
  asc = 1
  desc = -1

  constructor(private fb: FormBuilder, private cpmService: CpmService) {
    this.cpmService.getSecurityList().then(response => {
      this.securityList = response.map(x => x.securitySymbol)
    })
  }

  ngOnInit() {
    this.symbol = this.dataTrading['symbol']
    this.radio = this.dataTrading['radio']
    this.period = this.dataTrading['period']
    this.securityIdPsims = this.dataTrading['securityIdPsims']

    this.createForm()
    this.rebuildForm()
  }

  createForm() {
    this.tradingForm = this.fb.group({
      searchInputControl: new FormControl(''),
      checkBoxControl: new FormControl(true),
      items: this.fb.array([])
    })
  }
  rebuildForm() {
    this.headerTradingComparePopu = [
      'No.',
      'Symbol',
      'Sector/Market',
      'Price (Baht)',
      'Volume trade/Day (M.shares)',
      'Value trade/Day (M.Baht)',
      'Market cap (M.Baht)',
      'Turnover ratio (%)',
      'P/E'
    ]

    this.tradingForm.reset({})

    let listChild = []
    this.cpmService
      .getSecurityTradingByPeer(this.symbol, this.period, this.radio)
      .then(res => {
        const result = res
        result.map(obj => {
          const data = obj
          data['bgColor'] =
            obj.securitySymbol === this.symbol ? 'hilight' : null
          data['inputChecked'] = true
          listChild.push(data)
        })

        listChild = this.sortList(listChild, 'securitySymbol', this.asc)
        this.setChilds(listChild)
      })
  }

  setChilds(listChild: any[]) {
    const childs = listChild.map(obj => this.fb.group(obj))
    const listFormArray = this.fb.array(childs)
    this.tradingForm.setControl('items', listFormArray)
  }

  get items(): FormArray {
    return this.tradingForm.get('items') as FormArray
  }

  getValue(i, name) {
    return this.tradingForm.value['items'][i][name]
  }

  onEnter(event) {
    const newValueUppercase = event.target.value.toUpperCase()
    this.searchInput = newValueUppercase
    this.searchResults = this.securityList
      .filter(x => x.startsWith(newValueUppercase))
      .splice(0, 5)

    if (event.key === 'Enter') {
      this.addSecuritySymbolElement()
    }
  }

  addSecuritySymbolElement() {
    const securitySymbol = this.tradingForm
      .get('searchInputControl')
      .value.toUpperCase()
    const securityElement = this.items.value.find(
      x => x.securitySymbol === securitySymbol
    )

    if (securityElement) {
      return
    }

    this.cpmService
      .getPopupSecurityTrading(securitySymbol, 'local', this.period)
      .then(response => {
        response.map(obj => {
          obj.inputChecked = true
          this.items.push(this.fb.group(obj))
        })
      })
  }

  onDelete(id) {
    this.items.removeAt(id)
  }

  onSubmit() {
    const postData = {
      peer: [],
      securityIdPsims: this.securityIdPsims
    }
    this.tradingForm.value['items']
      .filter(obj => obj.inputChecked === true)
      .map(item => {
        postData['peer'].push(item.securityIdPsims)
      })
    const body = {
      peer: postData.peer,
      securityIdPsims: postData.securityIdPsims
    }

    this.cpmService.updateSecurityTradingByPeer(body).then(
      response => {
        if (response.status === 'FAIL') {
          alert(response.message)
        }
        this.closeModal.emit(this.dataTrading)
      },
      err => {}
    )
  }
  sortList(list, key, sort) {
    list.sort((obj1, obj2) => {
      if (obj1[key] > obj2[key]) {
        return 1 * sort
      }
      if (obj1[key] < obj2[key]) {
        return -1 * sort
      }
      return 0
    })

    return list
  }
  changeCheckBox(event) {
    for (let i = 0; i < this.items.length; i++) {
      this.items
        .get(i.toString())
        .get('inputChecked')
        .setValue(event)
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/trading-compare-to-peer-popup/trading-compare-to-peer-popup.component.ts